<template>
  <div class="content">
    <card class="ebg-toolbar">
      <div class="ebg-toolbar-row">
        <div class="ebg-artist-wrap col-md-5">
          <ArtistSelect :is-filter="true" :show-members="false" @unitChangeEvent="onUnitChange" />
        </div>
        <base-button type="default" @click="goForm()">그룹 추가</base-button>
      </div>
    </card>

    <template v-if="unitId">
      <div v-if="groups.length === 0" class="ebg-empty">조건에 맞는 배너 그룹이 없습니다.</div>
      <div v-else>
        <div class="ebg-card-col" v-for="group in groups" :key="group.groupId">
          <card class="ebg-card text-left" @click.native="goForm(group.groupId)">
            <!-- 타이틀 헤더 -->
            <div class="ebg-group-header">
              <div class="ebg-group-left">
                <div class="ebg-group-badges">
                  <span class="badge badge-pill badge-info">{{ layoutLabel(group.layoutType) }}</span>
                  <span class="badge badge-pill" :class="group.state === 1 ? 'badge-success' : 'badge-secondary'">
                    {{ group.state === 1 ? "표시" : "숨김" }}
                  </span>
                </div>
                <div class="ebg-group-titles">
                  <p class="ebg-group-title">{{ group.title }}</p>
                  <p v-if="group.titleEn" class="ebg-group-subtitle">{{ group.titleEn }}</p>
                  <p v-if="group.titleJa" class="ebg-group-subtitle">{{ group.titleJa }}</p>
                </div>
              </div>
              <span class="ebg-group-count">배너 {{ activeBanners(group).length }} / 10</span>
            </div>

            <!-- 배너 프리뷰 -->
            <div class="ebg-banner-row" :class="'ebg-banner-row--' + group.layoutType.toLowerCase()">
              <div v-if="activeBanners(group).length === 0" class="ebg-no-banners">활성 배너 없음</div>
              <div v-for="(banner, i) in activeBanners(group)" :key="i" class="ebg-banner-item">
                <div class="ebg-banner-thumb">
                  <img v-if="banner.imageFileId" :src="imageUrl(banner.imageFileId)" :alt="banner.title" />
                  <div v-else class="ebg-banner-no-img"></div>
                </div>
                <p class="ebg-banner-title">{{ banner.title }}</p>
              </div>
            </div>
          </card>
        </div>
      </div>
    </template>
    <div v-else class="ebg-empty">아티스트를 선택해주세요.</div>
  </div>
</template>

<script>
import { Card, BaseButton } from "@/components/index";
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";

const LAYOUT_LABEL = { SQUARE: "정방형", HORIZONTAL: "가로형", VERTICAL: "세로형" };

export default {
  components: { Card, BaseButton, ArtistSelect },
  data() {
    return {
      unitId: null,
      groups: [],
    };
  },
  methods: {
    async onUnitChange({ unitId }) {
      this.unitId = unitId;
      await this.getGroups();
    },
    async getGroups() {
      if (!this.unitId) return;
      const res = await this.$axios.get("/eventBanner/groups", { params: { unitId: this.unitId } });
      this.groups = res.data.data || [];
    },
    activeBanners(group) {
      const now = Date.now();
      return (group.banners || []).filter((b) => {
        if (b.state !== 1) return false;
        if (b.startTime && new Date(b.startTime).getTime() > now) return false;
        if (b.endTime && new Date(b.endTime).getTime() < now) return false;
        return true;
      });
    },
    layoutLabel(layoutType) {
      return LAYOUT_LABEL[layoutType] || layoutType;
    },
    imageUrl(fileId) {
      return window.Endpoints.imageServerUrl + fileId;
    },
    goForm(groupId) {
      const query = groupId ? `/banner/eventBannerGroupForm?groupId=${groupId}&unitId=${this.unitId}` : `/banner/eventBannerGroupForm?unitId=${this.unitId}`;
      this.$router.push(query);
    },
  },
};
</script>

<style scoped lang="scss">
.ebg-toolbar-row {
  display: flex;
  gap: 12px;
  align-items: flex-end;

  > .btn {
    margin: 0;
  }
}

.ebg-artist-wrap {
  flex: 1;
}

.ebg-empty {
  padding: 60px 16px;
  border: 1px dashed #d9dde7;
  border-radius: 6px;
  background: #fff;
  color: #8898aa;
  text-align: center;
}

.ebg-card-col {
  margin-bottom: 16px;
}

.ebg-card {
  cursor: pointer;
  transition: box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(34, 42, 66, 0.12);
  }
}

/* 헤더 */
.ebg-group-header {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
}

.ebg-group-left {
  display: flex;
  flex: 1;
  gap: 10px;
  align-items: flex-start;
  min-width: 0;
}

.ebg-group-badges {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 4px;
  padding-top: 4px;
}

.ebg-group-titles {
  flex: 1;
  min-width: 0;
}

.ebg-group-title {
  margin: 0 0 2px;
  overflow: hidden;
  color: #1b1b1b;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.4px;
  line-height: 28px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ebg-group-subtitle {
  margin: 0;
  overflow: hidden;
  color: #8898aa;
  font-size: 13px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ebg-group-count {
  flex-shrink: 0;
  color: #8898aa;
  font-size: 0.82rem;
  white-space: nowrap;
  padding-top: 6px;
}

/* 배너 프리뷰 행 */
.ebg-banner-row {
  display: flex;
  gap: 16px;
  overflow-x: auto;
}

.ebg-banner-item {
  display: flex;
  flex: 1 0 0;
  min-width: 60px;
  max-width: 200px;
  flex-direction: column;
  gap: 8px;
}

.ebg-banner-row--horizontal .ebg-banner-item {
  max-width: 280px;
}

.ebg-banner-row--vertical .ebg-banner-item {
  max-width: 120px;
}

.ebg-banner-thumb {
  overflow: hidden;
  width: 100%;
  border: 1px solid rgba(194, 194, 194, 0.15);
  border-radius: 8px;
  background: #f7f7f7;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.ebg-banner-no-img {
  width: 100%;
  height: 100%;
  background: #e9ecef;
}

/* layoutType별 이미지 비율 */
.ebg-banner-row--square .ebg-banner-thumb {
  aspect-ratio: 1 / 1;
}
.ebg-banner-row--horizontal .ebg-banner-thumb {
  aspect-ratio: 16 / 9;
}
.ebg-banner-row--vertical .ebg-banner-thumb {
  aspect-ratio: 380 / 539;
}

.ebg-banner-title {
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  color: #1b1b1b;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.4px;
  line-height: 20px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.ebg-no-banners {
  padding: 24px 0;
  color: #adb5bd;
  font-size: 0.82rem;
  text-align: center;
  width: 100%;
}
</style>
